<div class="dialog-box">
  <div class="mat-dialog-title" mat-dialog-title>
      <div id="lblHeading">
          ATTACHMENT
          <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i>
      </div>
  </div>
</div>
<div mat-dialog-content class="">
  <div class="row m-0 eip-pb-20">
      <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}" *ngIf="documentList.length>0">
          <kendo-grid #docGrid [kendoGridBinding]="documentList" [style.maxHeight]="540" [pageable]="false" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="false" [filterable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
              <ng-template kendoPagerTemplate>
                  <div class="k-pager-left">
                      <kendo-pager-info></kendo-pager-info>
                  </div>
                  <div class="k-pager-right">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-input></kendo-pager-input>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                  <div class="k-grid-toolbar-content d-flex align-content-center">
                      <div class="flex-grow-1 title-container">
                          <p class="title">Documents</p>
                      </div>
                  </div>
              </ng-template>
              <kendo-grid-column title="Sl.No." filterable="false" width="60">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      {{rowIndex+1}}
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="documentNo" title="Document No." width="250">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.documentNo}}" eipTooltipPosition="auto">
                          {{dataItem.documentNo}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="title" title="Title" width="150">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.title}}" eipTooltipPosition="auto">
                          {{dataItem.title}}
                      </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="revision" title="Revision" width="80" id="glblASRFRequiredQuantity" [minResizableWidth]="90">
                  <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                      Revision
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.revision}}" eipTooltipPosition="auto">{{dataItem.revision}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="createdBy" title="Created By" width="150">
                  <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                      Created By
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.createdBy}}" eipTooltipPosition="auto">{{dataItem.createdBy}}</span>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
      <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen}" *ngIf="messageList.length>0">
          <kendo-grid #docGrid [kendoGridBinding]="messageList" [style.maxHeight]="540" [pageable]="false" id="ArForActionLandingGrid" [sortable]="true" [resizable]="true" [reorderable]="false" [filterable]="false" [scrollable]="true" class="form-group-grid auto-complete-equal kg-hover-icon k-resizable-grid">
              <ng-template kendoPagerTemplate>
                  <div class="k-pager-left">
                      <kendo-pager-info></kendo-pager-info>
                  </div>
                  <div class="k-pager-right">
                      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                      <kendo-pager-input></kendo-pager-input>
                      <kendo-pager-next-buttons></kendo-pager-next-buttons>
                  </div>
              </ng-template>
              <ng-template kendoGridToolbarTemplate>
                  <div class="k-grid-toolbar-content d-flex align-content-center">
                      <div class="flex-grow-1 title-container">
                          <p class="title">Messages</p>
                      </div>
                  </div>
              </ng-template>
              <kendo-grid-column title="Sl.No." filterable="false" width="60">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      {{rowIndex+1}}
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="messageNumber" title="Message No." width="200">
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.messageNumber}}" eipTooltipPosition="auto">
                          {{dataItem.messageNumber}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="messageSubject" title="Subject" width="140">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.messageSubject}}" eipTooltipPosition="auto">
                          {{dataItem.messageSubject}}
                      </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="from" title="From" width="140" id="glblASRFRequiredQuantity" [minResizableWidth]="90">
                  <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                      From
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.fromMemberName}}" eipTooltipPosition="auto">{{dataItem.fromMemberName}}</span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="to" title="To" width="140">
                  <ng-template kendoGridHeaderTemplate let-dataItem="dataItem">
                      To
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                      <span class="no-wrap" eipTooltip="{{dataItem.toMemberName}}" eipTooltipPosition="auto">{{dataItem.toMemberName}}</span>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </div>
</div>